import { Component, Inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IconComponent } from "../../helper/icon/icon.component";
import { SubscriptionTier } from "../../service/account.service";

@Component({
  selector: 'app-connect-patreon-success',
  imports: [MatDialogModule, MatButtonModule, MatProgressSpinnerModule, IconComponent],
  templateUrl: './connect-patreon-success.component.html',
  styleUrl: './connect-patreon-success.component.less'
})
export class ConnectPatreonSuccessComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { 
      patreon_account_name: string
      patreon_tier: SubscriptionTier
      isGuest?: boolean
      expireDate?: string
      vrchat_name?: string
    } 
  ) {}
}
